(function (window, document, $) {

    $(document).ready(function () {
        
        // Category filter =============================================================================================

        function updateCategoryFilter(e) {

            var $filterForm = $('[data-filter-form]');
            var post_type   = $filterForm.data( 'filter-form' );

            if (e !== null) {

                // set button selected
                if ($(this).hasClass('blogpost-filter__category-radio')) {
                    $filterForm.find('.blogpost-filter__category-button').removeClass('selected');
                    $(this).next().addClass('selected');
                }

                window.xhrPool.abortAll();

                $.ajax({
                    type: 'POST',
                    url: themevars.ajaxurl,
                    data: $filterForm.serialize(),
                    dataType: 'json',

                    complete: function (e) { },

                    success: function (response) {

                        var $target   = $('[data-filter-target="' + post_type + '"]');
                        var $template = $target.children().first().clone();
                        var selected_category = $filterForm.find( '[data-filter-form-field] :selected' ).val();
                        
                        // check if a radio button is checked
                        if (!selected_category) {
                            selected_category = $filterForm.find( '[data-filter-form-field]:checked' ).val();
                        }
                        
                        var $load_more_button = $('[data-load-more-type="' + post_type + '"]');
                        $target.empty();

                        $('.infinity-scroll').remove();
                        $load_more_button.removeClass( 'infinity-stop' );

                        for (var i in response.posts) {
                            var $wrapper = $template.clone();
                            $wrapper
                                .css('opacity', 0)
                                .empty()
                                .html($(response.posts[i].html))
                                .appendTo($target)
                                .delay(i * 100)
                                .animate({ opacity: 1 });
                        }

                        if (response.datalayer_html) {
                            $target.append(response.datalayer_html);
                        }

                        $('[data-filter-count]').html( response.count_found );
                        $('[data-filter-total]').html( response.count_total );

                        $load_more_button.data( 'load-more-offset', response.count_found );
                        $load_more_button.data( 'load-more-category', selected_category );
                    },
                    error: function (e) { }
                });
            }

        }

        updateCategoryFilter(null);
        $('body').on('change', '[data-filter-form] input, [data-filter-form] select', updateCategoryFilter);
    });

}(window, document, jQuery));
